
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"26.247","height":"26.247"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 6.562h6.562V0H0zm9.843 19.685H16.4v-6.562H9.843zm-9.843 0h6.562v-6.562H0zM0 16.4h6.562V9.843H0zm9.843 0H16.4V9.843H9.843zM19.685 0v6.562h6.562V0zM9.842 6.562H16.4V0H9.843zm9.843 9.838h6.562V9.843h-6.562zm0 9.843h6.562v-6.558h-6.562z","fill":"currentColor"}})])
          )
        }
      }
    